


export enum ContractTypes {
    serviceContracts = 1,
    distanceSale=2,
    securityInfo=3,
    refundTerms = 4,
    kvkkContracts = 5,
    contactForm = 6,
  }